<template>
  <div class="page-container">
    <h1 class="page-title">未成年人防沉迷</h1>
    
    <div class="content-section">
      <h2 class="section-title">防沉迷系统介绍</h2>
      <p class="section-text">
        为贯彻落实《关于防止未成年人沉迷网络的意见》《关于进一步严格管理切实防止未成年人沉迷网络游戏的通知》等文件精神，新疆音线平台特建立未成年人网络保护及防沉迷系统，通过身份识别、使用时段限制、消费限制等多种手段，保护未成年人健康成长。
      </p>
    </div>
    
    <div class="content-section">
      <h2 class="section-title">防沉迷措施</h2>
      
      <div class="measure-item">
        <h3 class="measure-title">实名认证系统</h3>
        <p class="measure-desc">
          所有用户必须进行实名认证，平台将根据国家权威数据库核验用户真实身份信息，识别未成年人用户。
        </p>
      </div>
      
      <div class="measure-item">
        <h3 class="measure-title">使用时段限制</h3>
        <p class="measure-desc">
          未成年人用户仅可在周五、周六、周日和法定节假日的20:00-21:00使用本平台服务，其他时间段将无法登录。
        </p>
      </div>
      
      <div class="measure-item">
        <h3 class="measure-title">消费限制</h3>
        <p class="measure-desc">
          <strong>8周岁以下：</strong>不允许任何消费行为<br>
          <strong>8-16周岁：</strong>单次消费不超过50元，每月累计不超过200元<br>
          <strong>16-18周岁：</strong>单次消费不超过100元，每月累计不超过400元
        </p>
      </div>
      
      <div class="measure-item">
        <h3 class="measure-title">内容筛选</h3>
        <p class="measure-desc">
          对未成年人用户展示内容进行筛选，屏蔽不适宜未成年人观看的内容，营造健康绿色的网络环境。
        </p>
      </div>
      
      <div class="measure-item">
        <h3 class="measure-title">家长监护</h3>
        <p class="measure-desc">
          提供家长监护功能，家长可以通过监护系统了解未成年人使用情况，设置使用时间和消费限制，必要时可申请关闭账号。
        </p>
      </div>
    </div>
    
    <div class="content-section">
      <h2 class="section-title">家长监护申请流程</h2>
      <ol class="process-list">
        <li>家长下载并填写《家长监护申请表》</li>
        <li>准备家长身份证明、亲子关系证明（如户口本）</li>
        <li>将申请表和证明材料发送至指定邮箱或邮寄至客服中心</li>
        <li>客服人员审核材料（1-3个工作日）</li>
        <li>审核通过后，开通家长监护功能，并告知家长操作方式</li>
      </ol>
    </div>
    
    <div class="content-section">
      <h2 class="section-title">监护系统功能</h2>
      <ul class="feature-list">
        <li>查看未成年人账号使用记录</li>
        <li>设置使用时间限制</li>
        <li>设置消费限额</li>
        <li>远程强制下线</li>
        <li>申请临时或永久关闭账号</li>
      </ul>
    </div>
    
    <!-- <div class="content-section">
      <h2 class="section-title">联系方式</h2>
      <p class="section-text">
        未成年人保护专线：0991-7654321<br>
        家长监护邮箱：minor_protection@xinjiangmusic.com<br>
        工作时间：周一至周日 9:00-21:00
      </p>
      <p class="section-text">
        <a href="javascript:void(0)" class="download-link">下载《家长监护申请表》</a>
      </p>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'MinorProtection'
}
</script>

<style scoped>
.page-container {
  padding: 20px;
  max-width: 1000px;
  margin: 0 auto;
  padding-bottom: 40px;
}

.page-title {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 30px;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.content-section {
  margin-bottom: 30px;
}

.section-title {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 15px;
  color: #333;
}

.section-text {
  font-size: 14px;
  line-height: 1.8;
  color: #333;
  margin-bottom: 15px;
  text-align: justify;
}

.measure-item {
  margin-bottom: 20px;
  background-color: #f9f9f9;
  border-radius: 4px;
  padding: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.measure-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
  color: #4169e1;
}

.measure-desc {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  text-align: justify;
}

.process-list, .feature-list {
  padding-left: 20px;
  margin-bottom: 15px;
}

.process-list li, .feature-list li {
  font-size: 14px;
  line-height: 1.8;
  color: #333;
  margin-bottom: 10px;
  text-align: justify;
}

.download-link {
  color: #4169e1;
  text-decoration: none;
  font-weight: 500;
}

.download-link:hover {
  text-decoration: underline;
}
</style> 